import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
const points = ['Te levantás bien y a media mañana ya tenés la panza dura e hinchada.', 'Probaste dietas sueltas y listas de internet, pero nunca sabés qué te cayó mal.', 'Los gases y el dolor te condicionan la ropa, las salidas y las comidas con otros.', 'No sabés en qué orden hacer las cosas: qué sacar, qué reponer y cuándo reintroducir.', 'Cada recaída te deja sin energía y con la sensación de volver siempre al punto cero.'];
export function PainPoints() {
  return <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-81" data-mp="1nzjzsdkbt9bz">
      <div className="mx-auto max-w-4xl" data-id="element-82" data-mp="1o14tk0ytgo8s">
        <header className="text-center" data-id="element-83" data-mp="1syeqs2sg6476">
          <h2 className="font-display text-3xl font-bold sm:text-5xl" data-id="element-84" data-mp="1szg288ddkspf">
            ¿Cuántos días más vas a terminar hinchada?
          </h2>
          <p className="mx-auto mt-6 max-w-3xl text-slate-300" data-id="element-85" data-mp="3ibs0k7jbwkfo">
            Querés comer tranquila, pero cada intento termina en hinchazón, gases
            y la duda de qué fue lo que te hizo mal.
          </p>
          <p className="mt-4 font-semibold text-brand-light" data-id="element-86" data-mp="1u1lp5b9rjvaf">
            El problema no es tu fuerza de voluntad. Es que te faltaba un
            protocolo claro y ordenado.
          </p>
        </header>
        <div className="mt-10 space-y-3" data-id="element-87" data-mp="23rncu1y7fbot">
          {points.map((point, index) => <motion.div key={point} initial={{
          opacity: 0,
          x: -14
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="flex gap-3 rounded-xl border border-red-900/70 bg-[#250c0c] p-4 sm:p-5" data-id="element-88" data-mp="1g1t0dlhsrp53" data-mpi={index}>
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" aria-hidden="true" data-id="element-89" data-mp="1k2moaev8p3xz" />
              <p className="text-sm leading-relaxed text-slate-200 sm:text-base" data-id="element-90" data-mp="30gcrljejbo6k">{point}</p>
            </motion.div>)}
        </div>
        <p className="mt-12 text-center font-display text-2xl font-bold italic text-brand-gold sm:text-3xl" data-id="element-91" data-mp="2vkxfavw6e0c9">
          ¿Y si tuvieras un protocolo claro desde mañana mismo?
        </p>
      </div>
    </section>;
}